module.exports = __webpack_public_path__ + "img/2.efeea037.png";